export const AYS_QUALITAETSBERICHTE_YEARS: number[] = [
  2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024
];
export const AYS_QUALITAETSBERICHTE_YEARS_LATEST = 2024;
